/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarioVisibilitaCorpoDto } from '../../models/calendario-visibilita-corpo-dto';

export interface ApiCalendarioCalendarioVisibilitaListGet$Params {
    /**
     * Corpo per cui caricare la configurazione
     */
    corpoId: number;
}

export function apiCalendarioCalendarioVisibilitaListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiCalendarioCalendarioVisibilitaListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<CalendarioVisibilitaCorpoDto>>> {
    const rb = new RequestBuilder(rootUrl, apiCalendarioCalendarioVisibilitaListGet.PATH, 'get');
    if (params) {
        rb.query('corpoId', params.corpoId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<CalendarioVisibilitaCorpoDto>>;
        }),
    );
}

apiCalendarioCalendarioVisibilitaListGet.PATH = '/api/calendario/calendario-visibilita-list';
